/**
 * Better Objects cart upsells + free-shipping bar.
 * Loaded once in theme.liquid — survives cart drawer morphing.
 */
(function () {
  // Thresholds mirror the Shopify delivery profiles (display only — checkout
  // is the source of truth). General profile: US/CA/DK $65, UK $69, EU €70,
  // ROW $80. WindCell profile: free ≥ $549 (≈€499/£449) in all zones.
  var EU_CODES = 'AT BE DE NL FR LU CZ FI IE IT NO PL PT ES SE HR GR LT RO SK SI EE HU LV MT BG CY RS GG IM JE'.split(' ');
  // General profile (StitchGrid etc.): EU zones free at €70 (raised from €60 on 2026-10-20 with the €55 EU price), UK at ~£60 (checkout rule $77), 2026-09-30:
  // a stamp + one add-on pays shipping, a stamp + two add-ons (or two stamps) ships free.
  // US free at $64 (set by Nicolas in Admin 2026-09-30, verified): stamp + two add-ons or two stamps ships free.
  // CA shares that USD rule; the bar compares in CAD, so CA = $64 x ~1.45 = C$93.
  var FREE_SHIPPING = { US: 6400, CA: 9300, GB: 6000, DK: 6500, EU: 7000, DEFAULT: 8000 };
  var WC_FREE_SHIPPING = { GB: 44900, EU: 49900, DEFAULT: 54900 };
  // Peak Dough ships on its own delivery profile: free at $180 in the US, Canada,
  // UK and Europe zones, $299 everywhere else. USD cents, converted to the
  // visitor's currency in getPdThreshold (Shopify converts the checkout rule the same way).
  var PD_FREE_SHIPPING = { US: 18000, CA: 18000, GB: 18000, DK: 18000, EU: 18000, DEFAULT: 29900 };
  // LastFloss ships on its own delivery profile — free at $45 (USD, converted per zone).
  var LF_FREE_SHIPPING = { DEFAULT: 4500 };
  // Ice Luge ships on its own delivery profile (2026-10-28), worldwide: free from $190 (€200 in the
  // euro zone), so 3 Ice Luges or 2 + the shot glasses ship free.
  var IL_FREE_SHIPPING = { DEFAULT: 19000 };
  // Gravity Pour ships on its own delivery profile (2026-11-02), US only: $9.95 below $169, free from
  // $169, so 1 stand ($129) + Kiln Cups or + spare cone (both $188) ships free.
  var GP_FREE_SHIPPING = { DEFAULT: 16900 };

  // UI strings per storefront locale. {amount} is replaced with a formatted price.
  // Item titles/benefits are keyed by product handle and override the EN config.
  var I18N = {
    en: {
      away: "You're {amount} away from free shipping",
      unlocked: 'Free shipping unlocked!',
      badge: '🚚 unlocks free shipping',
      add: 'Add to order',
      adding: 'Adding…',
      error: 'Something went wrong — please try again',
      save: 'Early-bird saving',
      items: {}
    },
    de: {
      away: 'Noch {amount} bis zum kostenlosen Versand',
      unlocked: 'Kostenloser Versand freigeschaltet!',
      badge: '🚚 schaltet kostenlosen Versand frei',
      add: 'Hinzufügen',
      adding: 'Wird hinzugefügt…',
      error: 'Etwas ist schiefgelaufen — bitte erneut versuchen',
      save: 'Frühbucher-Ersparnis',
      items: {
        'stitchgrid-thread-ink-refill-kit': { title: 'Mehr Garne', benefit: '4 weitere Sashiko-Garne' },
        'stitchgrid-extra-pattern-book': { title: 'Exklusives Musterbuch', benefit: '30 zusätzliche Sashiko-Muster' },
        'windcell-mounting-rod-kit': { title: 'Montagestangen-Set', benefit: '2m faltbare Stange, Stahlseile + Erdanker' },
        'windcell-travel-case': { title: 'Transportkoffer', benefit: 'Hartschalenkoffer mit Schaumstoff für Transport und Lagerung' },
        'stitchgrid': { title: 'Extra StitchGrid', benefit: 'Sichern Sie sich ein zweites' },
        'windcell-aura': { title: 'Zweite WindCell Aura', benefit: '15% Rabatt auf die zweite Einheit — automatisch angewendet' }
      }
    },
    fr: {
      away: 'Plus que {amount} pour la livraison gratuite',
      unlocked: 'Livraison gratuite débloquée !',
      badge: '🚚 débloque la livraison gratuite',
      add: 'Ajouter',
      adding: 'Ajout…',
      error: 'Une erreur est survenue — veuillez réessayer',
      save: 'Économie early-bird',
      items: {
        'stitchgrid-thread-ink-refill-kit': { title: 'Plus de fils', benefit: '4 fils sashiko supplémentaires' },
        'stitchgrid-extra-pattern-book': { title: 'Livre de motifs exclusif', benefit: '30 motifs sashiko supplémentaires' },
        'windcell-mounting-rod-kit': { title: 'Kit de mât de montage', benefit: 'Mât pliable 2 m, câbles acier + piquets' },
        'windcell-travel-case': { title: 'Valise de transport', benefit: 'Coque rigide doublée de mousse pour transport et rangement' },
        'stitchgrid': { title: 'StitchGrid supplémentaire', benefit: 'Prenez-en un deuxième' },
        'windcell-aura': { title: 'Deuxième WindCell Aura', benefit: '15% de réduction sur la deuxième unité — appliquée automatiquement' }
      }
    },
    it: {
      away: 'Ti mancano {amount} per la spedizione gratuita',
      unlocked: 'Spedizione gratuita sbloccata!',
      badge: '🚚 sblocca la spedizione gratuita',
      add: 'Aggiungi',
      adding: 'Aggiunta…',
      error: 'Qualcosa è andato storto — riprova',
      save: 'Risparmio early bird',
      items: {
        'stitchgrid-thread-ink-refill-kit': { title: 'Altri fili', benefit: '4 fili sashiko in più' },
        'stitchgrid-extra-pattern-book': { title: 'Libro di motivi esclusivo', benefit: '30 motivi sashiko extra' },
        'windcell-mounting-rod-kit': { title: 'Kit asta di montaggio', benefit: 'Asta pieghevole 2 m, cavi in acciaio + picchetti' },
        'windcell-travel-case': { title: 'Custodia da viaggio', benefit: 'Custodia rigida con interno in schiuma per viaggio e conservazione' },
        'stitchgrid': { title: 'StitchGrid extra', benefit: 'Prendine un secondo' },
        'windcell-aura': { title: 'Seconda WindCell Aura', benefit: '15% di sconto sulla seconda unità — applicato automaticamente' }
      }
    },
    pl: {
      away: 'Zostało Ci {amount} do darmowej wysyłki',
      unlocked: 'Darmowa wysyłka odblokowana!',
      badge: '🚚 odblokowuje darmową wysyłkę',
      add: 'Dodaj do zamówienia',
      adding: 'Dodawanie…',
      error: 'Coś poszło nie tak — spróbuj ponownie',
      save: 'Oszczędność w przedsprzedaży',
      items: {
        'stitchgrid-thread-ink-refill-kit': { title: 'Więcej nici', benefit: '4 dodatkowe nici Sashiko' },
        'stitchgrid-extra-pattern-book': { title: 'Ekskluzywny poradnik wzorów', benefit: '30 dodatkowych wzorów sashiko' },
        'stitchgrid': { title: 'Dodatkowy StitchGrid', benefit: 'Zdobądź drugi egzemplarz' }
      }
    },
    nl: {
      away: 'Je bent nog {amount} verwijderd van gratis verzending',
      unlocked: 'Gratis verzending ontgrendeld!',
      badge: '🚚 ontgrendelt gratis verzending',
      add: 'Toevoegen aan bestelling',
      adding: 'Bezig met toevoegen…',
      error: 'Er ging iets mis — probeer het opnieuw',
      save: 'Early-bird voordeel',
      items: {
        'stitchgrid-thread-ink-refill-kit': { title: 'Meer garens', benefit: '4 extra Sashiko-garens' },
        'stitchgrid-extra-pattern-book': { title: 'Exclusief patronenboek', benefit: '30 extra sashiko-patronen' },
        'stitchgrid': { title: 'Extra StitchGrid', benefit: 'Neem er een tweede bij' }
      }
    },
    sv: {
      away: 'Du är {amount} från fri frakt',
      unlocked: 'Fri frakt upplåst!',
      badge: '🚚 låser upp fri frakt',
      add: 'Lägg till i beställningen',
      adding: 'Lägger till…',
      error: 'Något gick fel — försök igen',
      save: 'Early-bird-besparing',
      items: {
        'stitchgrid-thread-ink-refill-kit': { title: 'Fler trådar', benefit: '4 fler Sashiko-trådar' },
        'stitchgrid-extra-pattern-book': { title: 'Exklusiv mönsterbok', benefit: '30 extra sashiko-mönster' },
        'stitchgrid': { title: 'Extra StitchGrid', benefit: 'Skaffa en till' }
      }
    }
  };

  var LOCALE = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var T = I18N[LOCALE] || I18N.en;
  // Cart C (holdback bo_cart_c_v1, snippets/bo-cart-ab.liquid): compact rows say "+ Add".
  var CART_C = document.documentElement.getAttribute('data-bo-cart') === 'B' && LOCALE === 'en';
  if (CART_C) T = Object.assign({}, T, { add: '+ Add' });
  function trackCart() {
    try { if (window.__boCartAB) window.__boCartAB.cart(); } catch (e) {}
  }

  function localizedItem(handle, field, fallback) {
    var item = T.items[handle];
    return (item && item[field]) || fallback;
  }

  // WindCell items ship on their own delivery profile with separate rates.
  var WC_HANDLES = ['windcell-aura', 'windcell-mounting-rod-kit', 'windcell-travel-case'];
  // Peak Dough items ship on their own delivery profile (free ≥ PD_FREE_SHIPPING).
  var PD_HANDLES = ['peak-dough-complete-kit', 'peak-dough-smart-heater', 'peak-dough-extra-sensor-lid', 'peak-dough-magnetic-lame-spatula'];
  // LastFloss items ship on their own delivery profile (free ≥ $45).
  var LF_HANDLES = ['lastfloss', 'lastfloss-refills', 'lastfloss-tongue-scraper'];
  // Ice Luge items ship on their own delivery profile (free ≥ $190).
  var IL_HANDLES = ['ice-luge', 'ice-luge-crystal-shot-glasses'];
  // Gravity Pour items ship on their own delivery profile (free ≥ $169, US only).
  var GP_HANDLES = ['gravity-pour', 'kiln-cups-set-of-4', 'gravity-pour-spare-cone'];

  // Add-ons only render when their parent product is in the cart.
  var ADDON_HANDLES = [
    { handle: 'stitchgrid-thread-ink-refill-kit', parent: 'stitchgrid', benefit: '4 more Sashiko threads', title: 'More Threads' },
    { handle: 'stitchgrid-extra-pattern-book', parent: 'stitchgrid', benefit: '30 extra sashiko patterns', title: 'Exclusive Pattern Book' },
    { handle: 'windcell-mounting-rod-kit', parent: 'windcell-aura', benefit: '2m collapsible rod, steel cables + ground stakes', title: 'Mounting Rod Kit' },
    { handle: 'windcell-travel-case', parent: 'windcell-aura', benefit: 'Hard-shell foam-lined case for travel and storage', title: 'Travel Case' },
    { handle: 'peak-dough-smart-heater', parent: 'peak-dough-complete-kit', benefit: 'Keeps your starter warm in a cold kitchen', title: 'Smart Heater' },
    { handle: 'peak-dough-magnetic-lame-spatula', parent: 'peak-dough-complete-kit', benefit: 'Precision scoring blade + silicone spatula', title: 'Magnetic Lame + Spatula' },
    // Cart-only (Nicolas, 2026-09-29): offered once a Peak Dough buyer has the bowl kit, or
    // already has both other add-ons. Pitched as a spare, not as tracking jar + bowl at once.
    { handle: 'peak-dough-extra-sensor-lid', parent: 'peak-dough-complete-kit', benefit: 'A second lid, so one is always charged and ready', title: 'Spare Sensor Lid',
      showIf: function (cartItems, inCart) {
        return variantInCart(PD_BOWL_VARIANT, cartItems) ||
          (inCart['peak-dough-smart-heater'] && inCart['peak-dough-magnetic-lame-spatula']);
      } },
    { handle: 'lastfloss-refills', parent: 'lastfloss', benefit: 'A fresh 3-pack of floss refills', title: 'Refills (3-pack)' },
    { handle: 'lastfloss-tongue-scraper', parent: 'lastfloss', benefit: 'Reusable tongue scraper to finish your routine', title: 'Tongue Scraper' },
    { handle: 'ice-luge-crystal-shot-glasses', parent: 'ice-luge', benefit: 'Set of 3, in their own gift box', title: '3 Crystal Shot Glasses' },
    { handle: 'kiln-cups-set-of-4', parent: 'gravity-pour', benefit: 'Glazed in the fire, so no two are the same', title: 'Kiln Cups, Set of 4' },
    // No multi-buy offer on Gravity Pour (Nicolas, 2026-11-02): the add-ons are the only nudge.
    { handle: 'gravity-pour-spare-cone', parent: 'gravity-pour', benefit: 'For two cups back to back', title: 'Second Ceramic Cone' }
  ];

  // Ice Luge quantity upgrades (2026-10-28): one variant, quantity tiers by automatic discount
  // ("Ice Luge: 2 for $159" = $9.50 off each at 2+, "Ice Luge: 3 for $198" = $23 off each at 3+).
  // A cart with 1 or 2 is offered 3 by raising the line's quantity in place.
  var IL_VARIANT = 55717754667384;
  var IL_QTY_NAMES = { 3: '3 Ice Luges' };
  var IL_QTY_BENEFIT = { 3: 'One to keep, two to give' };
  // Tier totals per currency, as the checkout discounts work them out (keep in step with
  // il-config.liquid): USD $9.50 / $23 off each unit; EUR markets (€100 fixed price) "2 for €180" /
  // "3 for €228" = 10% / 24% off; other currencies get the USD amounts converted, so use the share.
  var IL_TIER_RATIO = { 1: 1, 2: 159 / 178, 3: 198 / 267 };
  var IL_TIER_RATIO_EUR = { 1: 1, 2: 0.9, 3: 0.76 };
  // UK (fixed price £80): "2 for £144" / "3 for £180" = 10% / 25% off.
  var IL_TIER_RATIO_GBP = { 1: 1, 2: 0.9, 3: 0.75 };
  var IL_TIER_OFF_USD = { 1: 0, 2: 950, 3: 2300 };
  function ilTierTotal(unit, qty) {
    var t = Math.min(qty, 3), cur = activeCurrency();
    if (cur === 'USD') return (unit - IL_TIER_OFF_USD[t]) * qty;
    var r = cur === 'EUR' ? IL_TIER_RATIO_EUR : (cur === 'GBP' ? IL_TIER_RATIO_GBP : IL_TIER_RATIO);
    return Math.round(unit * qty * r[t]);
  }

  // Peak Dough kit upgrade: Starter Jar -> Starter + Proofing Bowl, swapped in place.
  var PD_JAR_VARIANT = 55584438878584;
  var PD_BOWL_VARIANT = 55679537447288;
  var PD_BOWL_UPGRADE = {
    title: 'Upgrade to Starter + Proofing Bowl',
    benefit: 'Adds a glass proofing bowl with its own lid',
    img: 'https://cdn.shopify.com/s/files/1/0760/0049/3854/files/pd-kit-b3.jpg?v=1790600078'
  };
  var MAX_UPSELL_ROWS = 3;

  // "Add a second one" rows for hero products (max 2 units shown).
  // pctOff: display-only — the matching Shopify automatic discount applies at checkout.
  var HERO_UPSELLS = {
    'stitchgrid': {
      label: 'Extra StitchGrid',
      benefit: 'Get a second one',
      img: 'https://cdn.shopify.com/s/files/1/0760/0049/3854/files/ChatGPT_Image_May_6_2026_02_40_22_PM.png?v=1779476108'
    },
    'windcell-aura': {
      label: 'Second WindCell Aura',
      benefit: '15% off your second unit — applied automatically',
      pctOff: 0.15
    },
    'lastfloss': {
      label: 'Add another LastFloss',
      benefit: 'Bundle pricing applied automatically',
      img: 'https://cdn.shopify.com/s/files/1/0760/0049/3854/files/main-product-image.png?v=1784213649',
      maxCount: 3,
      hidePrice: true
    }
  };

  // USD reference prices for products whose compare-at may not be set in Shopify.
  // Used ONLY when the visitor's currency is USD: these are US cents, and printing
  // them as £/€ overstated savings in every other market (found 2026-10-20). Other
  // markets read the market's own compare_at_price from the localized product JSON.
  var COMPARE_CENTS = {
    'stitchgrid': 7900,
    'stitchgrid-thread-ink-refill-kit': 1195,
    'stitchgrid-extra-pattern-book': 1195,
    'windcell-aura': 29900,
    'windcell-mounting-rod-kit': 6900,
    'windcell-travel-case': 9900,
    // Peak Dough's two kits are variants of one product with different launch prices, so they are keyed by variant id.
    55584438878584: 19900, // Starter Jar
    55679537447288: 24800, // Starter + Proofing Bowl
    'peak-dough-smart-heater': 6900,
    'lastfloss': 2900,
    'lastfloss-refills': 1500,
    'lastfloss-tongue-scraper': 1000
  };

  function handleSwapClick(btn) {
    if (btn.disabled || requestInFlight) return;
    requestInFlight = true;
    setAllButtonsDisabled(true);
    setButtonLoading(btn);
    var from = parseInt(btn.dataset.swapFrom), to = parseInt(btn.dataset.vid);
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qty = cart.items.filter(function (i) { return i.variant_id === from; })
          .reduce(function (n, i) { return n + i.quantity; }, 0) || 1;
        var updates = {};
        // Quantity upgrade (Ice Luge): same variant, new quantity. Otherwise swap variants.
        if (btn.dataset.toQty) updates[to] = parseInt(btn.dataset.toQty, 10);
        else { updates[from] = 0; updates[to] = qty; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        setButtonSuccess(btn);
        btn.closest('.bo-upsell-row').classList.add('bo-upsell-row--added');
        requestInFlight = false;
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
        runInit();
      })
      .catch(function () {
        setButtonError(btn);
        setAllButtonsDisabled(false);
        requestInFlight = false;
      });
  }

  // Market-aware URL root ("/", "/en-gb/", "/de-de/" ...). A bare /products/x.js
  // returns the US price list, so a UK visitor saw £8/£12 for a £7/£10.50 add-on
  // (found 2026-10-20). Always prefix product JSON reads with the routes root.
  function routesRoot() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!r) return '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  // Shop currency -> presentment currency (Shopify.currency.rate, e.g. "0.75" for GBP).
  function toPresentment(usdCents) {
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    return Math.round(usdCents * rate);
  }

  // Localized product JSON per handle (market prices + compare-at), shared by
  // the add-on rows and the savings line.
  var productJsonCache = {};
  // Shopify answers bursts of /products/*.js with 429 (found 2026-11-02: 14 requests on
  // every page load knocked out ice-luge.js, so a 3-Ice-Luge cart showed a $10 saving
  // instead of $199). Retry 429/5xx with backoff, and never cache a failure.
  function fetchProduct(handle, attempt) {
    return fetch(routesRoot() + 'products/' + handle + '.js').then(function (r) {
      if (r.ok) return r.json();
      if ((r.status === 429 || r.status >= 500) && attempt < 3) {
        return new Promise(function (res) { setTimeout(res, 400 * Math.pow(3, attempt)); })
          .then(function () { return fetchProduct(handle, attempt + 1); });
      }
      return null;
    });
  }
  function productJson(handle) {
    if (!productJsonCache[handle]) {
      productJsonCache[handle] = fetchProduct(handle, 0)
        .catch(function () { return null; })
        .then(function (p) { if (!p) delete productJsonCache[handle]; return p; });
    }
    return productJsonCache[handle];
  }

  // Global in-flight lock — prevents double-tap and conflicting requests
  var requestInFlight = false;

  // Track whether the extras observer has been attached so we don't create duplicates
  var extrasObserved = false;

  // Preload add-on product data once so drawer opens instantly
  // Only the add-ons whose parent product is in the cart are loaded (was: all of them on
  // every page load, 2026-11-02). The Peak Dough kit itself is loaded too (tagged pd-kit)
  // when Peak Dough is in the cart, so the bowl-upgrade row can read the live price
  // difference between its two variants.
  function loadAddons(cartItems) {
    var inCart = {};
    (cartItems || []).forEach(function (i) { inCart[i.handle] = true; });
    var wanted = ADDON_HANDLES.filter(function (u) { return !u.parent || inCart[u.parent]; });
    if (inCart['peak-dough-complete-kit']) wanted = wanted.concat([{ handle: 'peak-dough-complete-kit', _kit: 'pd-kit' }]);
    return Promise.all(wanted.map(function (u) {
      return productJson(u.handle)
        .then(function (p) { return p ? Object.assign({}, p, { _benefit: u.benefit, _title: u.title, _type: u._kit || 'addon' }) : null; })
        .catch(function () { return null; });
    }));
  }

  function regionKey() {
    // Shopify sets Shopify.country (e.g. "US"); country_code is never defined on this
    // theme, which sent every visitor to the DEFAULT threshold (found 2026-09-29).
    var cc = ((window.Shopify && (window.Shopify.country || window.Shopify.country_code)) || '').toUpperCase();
    if (cc === 'US' || cc === 'CA' || cc === 'GB' || cc === 'DK') return cc;
    if (EU_CODES.indexOf(cc) !== -1) return 'EU';
    return 'DEFAULT';
  }

  function getThreshold() {
    var k = regionKey();
    return FREE_SHIPPING[k] || FREE_SHIPPING.DEFAULT;
  }

  function getWcThreshold() {
    var k = regionKey();
    return WC_FREE_SHIPPING[k] || WC_FREE_SHIPPING.DEFAULT;
  }

  function getPdThreshold() {
    var k = regionKey();
    var usd = PD_FREE_SHIPPING[k] || PD_FREE_SHIPPING.DEFAULT;
    return toPresentment(usd);
  }

  // LF_FREE_SHIPPING is USD (the profile rule is $45); convert like Peak Dough.
  function getLfThreshold() {
    var k = regionKey();
    return toPresentment(LF_FREE_SHIPPING[k] || LF_FREE_SHIPPING.DEFAULT);
  }

  // IL_FREE_SHIPPING is USD (the profile rule is $190); convert like Peak Dough.
  // The "Europe (EUR)" zone of the Ice Luge profile is set in euros: free from €200.
  function getIlThreshold() {
    if (activeCurrency() === 'EUR') return 20000;
    if (activeCurrency() === 'GBP') return 17000; // "United Kingdom (GBP)" zone: free from £170

    return toPresentment(IL_FREE_SHIPPING.DEFAULT);
  }

  function isIlHandle(handle) {
    return IL_HANDLES.indexOf(handle) !== -1;
  }

  // GP_FREE_SHIPPING is USD (the profile rule is $169, US zone only).
  function getGpThreshold() {
    return toPresentment(GP_FREE_SHIPPING.DEFAULT);
  }

  function isGpHandle(handle) {
    return GP_HANDLES.indexOf(handle) !== -1;
  }

  function isWcHandle(handle) {
    return WC_HANDLES.indexOf(handle) !== -1;
  }

  function isPdHandle(handle) {
    return PD_HANDLES.indexOf(handle) !== -1;
  }

  function isLfHandle(handle) {
    return LF_HANDLES.indexOf(handle) !== -1;
  }

  // Split cart into its shipping families.
  function familyTotals(cartItems) {
    var wc = 0, pd = 0, lf = 0, il = 0, gp = 0, general = 0;
    cartItems.forEach(function (item) {
      if (isWcHandle(item.handle)) wc += item.line_price;
      else if (isIlHandle(item.handle)) il += item.line_price;
      else if (isGpHandle(item.handle)) gp += item.line_price;
      else if (isPdHandle(item.handle)) pd += item.line_price;
      else if (isLfHandle(item.handle)) lf += item.line_price;
      else general += item.line_price;
    });
    return { wc: wc, pd: pd, lf: lf, il: il, gp: gp, general: general };
  }

  // Whole amounts print without decimals (£7, €12); anything else keeps its
  // cents (£10.50, $7.95) — rounding to 0 digits had turned £10.50 into £11.
  function money(cents) {
    var currency = activeCurrency();
    var digits = Math.round(cents) % 100 === 0 ? 0 : 2;
    var lang = (document.documentElement && document.documentElement.lang) || undefined;
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency', currency: currency,
        minimumFractionDigits: digits, maximumFractionDigits: digits
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }
  }

  function updateFsBar(cartTotal, threshold) {
    var gap = threshold - cartTotal;
    var pct = Math.min(100, Math.round((cartTotal / threshold) * 100));

    var fill = document.getElementById('bo-fs-fill');
    var label = document.getElementById('bo-fs-label');
    var extras = document.getElementById('bo-cart-extras');
    if (!fill || !label || !extras) return { shown: false, unlocked: false };

    extras.style.display = 'block';
    fill.style.width = pct + '%';

    var unlocked = gap <= 0;
    if (unlocked) {
      fill.style.background = '#2a7a2a';
      fill.classList.remove('bo-fs-bar__fill--unlocked');
      void fill.offsetWidth;
      fill.classList.add('bo-fs-bar__fill--unlocked');
      label.innerHTML = '🎉 <strong>' + T.unlocked + '</strong>';
    } else {
      fill.style.background = '';
      label.innerHTML = T.away.replace('{amount}', '<strong>' + money(gap) + '</strong>');
    }
    return { shown: true, unlocked: unlocked };
  }

  function variantInCart(variantId, cartItems) {
    return cartItems.some(function (item) { return item.variant_id === variantId; });
  }

  // Resize a Shopify CDN image for the 64px thumbnail slot (2x = 128w).
  // Adding a width param makes the CDN auto-serve WebP via Accept negotiation.
  function sizedImg(url, w) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // Set all upsell buttons into loading state
  function setAllButtonsDisabled(disabled) {
    document.querySelectorAll('.bo-upsell-row__btn:not(.bo-upsell-row__btn--added)').forEach(function (b) {
      b.disabled = disabled;
    });
  }

  function setButtonLoading(btn) {
    btn.disabled = true;
    btn.dataset.originalText = btn.textContent;
    btn.innerHTML =
      '<span class="bo-upsell-btn-spinner" aria-hidden="true"></span>' +
      '<span>' + T.adding + '</span>';
    btn.classList.add('bo-upsell-row__btn--loading');
  }

  function setButtonSuccess(btn) {
    btn.innerHTML = '✓';
    btn.classList.remove('bo-upsell-row__btn--loading');
    btn.classList.add('bo-upsell-row__btn--added');
  }

  function setButtonError(btn) {
    btn.disabled = false;
    btn.innerHTML = btn.dataset.originalText || T.add;
    btn.classList.remove('bo-upsell-row__btn--loading');
    // Show inline error message
    var row = btn.closest('.bo-upsell-row');
    if (row) {
      var existing = row.querySelector('.bo-upsell-row__error');
      if (!existing) {
        var err = document.createElement('p');
        err.className = 'bo-upsell-row__error';
        err.textContent = T.error;
        row.appendChild(err);
        setTimeout(function () { if (err.parentNode) err.parentNode.removeChild(err); }, 4000);
      }
    }
  }

  function handleAddClick(btn) {
    if (btn.disabled || requestInFlight) return;
    requestInFlight = true;
    setAllButtonsDisabled(true);
    setButtonLoading(btn);

    var vid = parseInt(btn.dataset.vid);
    var lineKey = btn.dataset.lineKey;
    var currentQty = parseInt(btn.dataset.currentQty || '0');

    var url, body;
    if (lineKey) {
      // Extra StitchGrid — use /cart/change.js with the exact line key.
      // Fetch current cart first to get authoritative qty, avoiding race condition
      // when cart has been mutated between drawer open and click.
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = cart.items.find(function (i) { return i.key === lineKey; });
          var qty = line ? line.quantity + 1 : currentQty + 1;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: lineKey, quantity: qty })
          });
        })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          setButtonSuccess(btn);
          btn.closest('.bo-upsell-row').classList.add('bo-upsell-row--added');
          requestInFlight = false;
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
          runInit();
        })
        .catch(function () {
          setButtonError(btn);
          setAllButtonsDisabled(false);
          requestInFlight = false;
        });
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          setButtonSuccess(btn);
          btn.closest('.bo-upsell-row').classList.add('bo-upsell-row--added');
          requestInFlight = false;
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
          runInit();
        })
        .catch(function () {
          setButtonError(btn);
          setAllButtonsDisabled(false);
          requestInFlight = false;
        });
    }
  }

  function renderUpsells(cartItems) {
    var container = document.getElementById('bo-upsell-rows');
    if (!container) return;

    var totals = familyTotals(cartItems);
    var generalThreshold = getThreshold();
    var wcThreshold = getWcThreshold();

    var handlesInCart = {};
    cartItems.forEach(function (item) { handlesInCart[item.handle] = true; });

    var heroRows = [];
    Object.keys(HERO_UPSELLS).forEach(function (handle) {
      var conf = HERO_UPSELLS[handle];
      var items = cartItems.filter(function (item) { return item.handle === handle; });
      if (!items.length) return;
      var count = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
      if (count >= (conf.maxCount || 2)) return;
      var line = items[0];
      var price = conf.pctOff ? Math.ceil(line.price * (1 - conf.pctOff) / 100) * 100 : line.price;
      heroRows.push({
        _type: 'hero-extra',
        handle: handle,
        title: localizedItem(handle, 'title', conf.label),
        _benefit: localizedItem(handle, 'benefit', conf.benefit),
        _img: conf.img || (line.image || ''),
        _variantId: line.variant_id,
        _lineKey: line.key,
        _currentQty: line.quantity,
        _price: price,
        _compare: conf.pctOff ? line.price : null,
        _hidePrice: conf.hidePrice || false
      });
    });

    // productJson caches successful reads, so later opens resolve instantly
    var cachePromise = loadAddons(cartItems);

    cachePromise.then(function (addons) {
      var rows = heroRows.slice();

      // Starter Jar in the cart and no bowl kit yet: offer the upgrade first.
      var jarLine = cartItems.find(function (i) { return i.variant_id === PD_JAR_VARIANT; });
      if (jarLine && !variantInCart(PD_BOWL_VARIANT, cartItems)) {
        var bowl = (addons || []).filter(Boolean).find(function (p) { return p._type === 'pd-kit'; });
        var bowlVariant = bowl && bowl.variants.find(function (v) { return v.id === PD_BOWL_VARIANT; });
        if (bowlVariant) {
          rows.unshift({
            _type: 'swap', handle: 'peak-dough-complete-kit',
            title: PD_BOWL_UPGRADE.title, _benefit: PD_BOWL_UPGRADE.benefit, _img: PD_BOWL_UPGRADE.img,
            _variantId: PD_BOWL_VARIANT, _swapFrom: PD_JAR_VARIANT,
            _price: (bowlVariant.price - jarLine.price) * jarLine.quantity
          });
        }
      }

      // 1 or 2 Ice Luges in the cart: offer 3 only (Nicolas, 2026-10-28), by raising the quantity.
      var ilQty = cartItems.filter(function (i) { return i.variant_id === IL_VARIANT; })
        .reduce(function (n, i) { return n + i.quantity; }, 0);
      var ilLine = cartItems.find(function (i) { return i.variant_id === IL_VARIANT; });
      if (ilLine && ilQty < 3) {
        rows.unshift({
          _type: 'swap', handle: 'ice-luge',
          title: 'Upgrade to ' + IL_QTY_NAMES[3], _benefit: IL_QTY_BENEFIT[3] + ' · ' + money(Math.round(ilTierTotal(ilLine.price, 3) / 3)).replace(/\.00(?=\D*$)/, '') + ' each',
          _img: ilLine.image, _variantId: IL_VARIANT, _swapFrom: IL_VARIANT, _toQty: 3,
          _price: ilTierTotal(ilLine.price, 3) - ilTierTotal(ilLine.price, ilQty)
        });
      }

      (addons || []).filter(Boolean).forEach(function (p) {
        if (p._type === 'pd-kit') return;
        var conf = ADDON_HANDLES.find(function (u) { return u.handle === p.handle; });
        if (conf && conf.parent && !handlesInCart[conf.parent]) return;
        if (conf && conf.showIf && !conf.showIf(cartItems, handlesInCart)) return;
        var vid = p.variants && p.variants[0] && p.variants[0].id;
        if (!variantInCart(vid, cartItems)) rows.push(p);
      });
      rows = rows.slice(0, MAX_UPSELL_ROWS);

      var upsellSection = document.querySelector('.bo-upsells');
      if (rows.length === 0) {
        if (upsellSection) upsellSection.style.display = 'none';
        return;
      }
      if (upsellSection) upsellSection.style.display = '';

      container.innerHTML = rows.map(function (p) {
        var isSwap = p._type === 'swap';
        var isHeroExtra = p._type === 'hero-extra' || isSwap;
        var vid = isHeroExtra ? p._variantId : p.variants[0].id;
        var img = isHeroExtra ? p._img : (p.featured_image || (p.images && p.images[0]) || '');
        var priceRaw = isHeroExtra ? p._price : p.variants[0].price;
        var compareRaw = isHeroExtra ? (p._compare || null) : (p.variants[0].compare_at_price || null);
        var hidePrice = isHeroExtra && p._hidePrice;
        var price = (isSwap ? '+' : '') + money(priceRaw);
        var compare = compareRaw ? money(compareRaw) : null;

        // Badge evaluates the row's own shipping family.
        var isWc = isWcHandle(p.handle);
        var isPd = isPdHandle(p.handle);
        var isLf = isLfHandle(p.handle);
        var isIl = isIlHandle(p.handle);
        var isGp = isGpHandle(p.handle);
        var famTotal = isWc ? totals.wc : (isPd ? totals.pd : (isLf ? totals.lf : (isIl ? totals.il : (isGp ? totals.gp : totals.general))));
        var famThreshold = isWc ? wcThreshold : (isPd ? getPdThreshold() : (isLf ? getLfThreshold() : (isIl ? getIlThreshold() : (isGp ? getGpThreshold() : generalThreshold))));
        var unlocksBadge = '';
        if (famTotal < famThreshold && famTotal + priceRaw >= famThreshold) {
          unlocksBadge = '<span class="bo-upsell-row__badge">' + T.badge + '</span>';
        }

        var titleHtml = localizedItem(p.handle, 'title', p._title || p.title);
        var benefit = localizedItem(p.handle, 'benefit', p._benefit || '');

        // Images: lazy-load with a lightweight placeholder background so drawer
        // opens without waiting for image network requests.
        return '<div class="bo-upsell-row" data-variant-id="' + vid + '">' +
          '<img class="bo-upsell-row__img" src="' + sizedImg(img, 128) + '" alt="' + (p._title || p.title) + '" width="64" height="64" loading="lazy" decoding="async">' +
          '<div class="bo-upsell-row__info">' +
            '<p class="bo-upsell-row__title">' + titleHtml + '</p>' +
            (benefit ? '<p class="bo-upsell-row__benefit">' + benefit + '</p>' : '') +
            unlocksBadge +
          '</div>' +
          '<div class="bo-upsell-row__actions">' +
            (hidePrice ? '' :
            '<p class="bo-upsell-row__price">' +
              '<span class="bo-upsell-row__sale">' + price + '</span>' +
              (compare ? ' <span class="bo-upsell-row__compare">' + compare + '</span>' : '') +
            '</p>') +
            '<button class="bo-upsell-row__btn" data-vid="' + vid + '"' +
              (isSwap ? ' data-swap-from="' + p._swapFrom + '"' + (p._toQty ? ' data-to-qty="' + p._toQty + '"' : '') :
                (isHeroExtra ? ' data-line-key="' + p._lineKey + '" data-current-qty="' + p._currentQty + '"' : '')) +
              ' aria-label="' + T.add + '">' + T.add + '</button>' +
          '</div>' +
        '</div>';
      }).join('');

      container.querySelectorAll('.bo-upsell-row__btn').forEach(function (btn) {
        btn.addEventListener('click', function () { btn.dataset.swapFrom ? handleSwapClick(btn) : handleAddClick(btn); });
      });
    });
  }

  function updateSavings(cartItems) {
    var usd = activeCurrency() === 'USD';
    var handles = [];
    cartItems.forEach(function (i) { if (handles.indexOf(i.handle) === -1) handles.push(i.handle); });
    Promise.all(handles.map(function (h) { return productJson(h); })).then(function (products) {
      var compareByVariant = {};
      products.forEach(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) { if (v.compare_at_price) compareByVariant[v.id] = v.compare_at_price; });
      });
      renderSavings(cartItems.reduce(function (sum, item) {
        var compare = usd
          ? (COMPARE_CENTS[item.variant_id] || COMPARE_CENTS[item.handle] || compareByVariant[item.variant_id])
          : compareByVariant[item.variant_id];
        if (!compare) return sum;
        var actual = item.final_price != null ? item.final_price : item.price;
        return sum + Math.max(0, compare - actual) * item.quantity;
      }, 0));
    });
  }

  function renderSavings(savings) {
    var el = document.getElementById('bo-cart-savings');

    if (savings <= 0) {
      if (el) el.remove();
      return;
    }

    var container = document.querySelector('.cart-totals__container');
    if (!container) return;

    if (!el) {
      el = document.createElement('span');
      el.id = 'bo-cart-savings';
      el.className = 'bo-cart-savings cart-totals__item';
      container.insertAdjacentElement('afterbegin', el);
    }

    el.innerHTML =
      '<span class="bo-cart-savings__label">' + T.save + '</span>' +
      '<span class="bo-cart-savings__value">' + money(savings) + '</span>';
  }

  function init() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) return;
        trackCart();
        // WindCell-only carts track the WindCell profile threshold; carts with
        // any general-profile items track that family (WindCell shipping is
        // rated separately at checkout either way).
        var totals = familyTotals(cart.items);
        var wcOnly = totals.general === 0 && totals.pd === 0 && totals.lf === 0 && totals.il === 0 && totals.gp === 0 && totals.wc > 0;
        var pdOnly = totals.general === 0 && totals.wc === 0 && totals.lf === 0 && totals.il === 0 && totals.gp === 0 && totals.pd > 0;
        var lfOnly = totals.general === 0 && totals.wc === 0 && totals.pd === 0 && totals.il === 0 && totals.gp === 0 && totals.lf > 0;
        var ilOnly = totals.general === 0 && totals.wc === 0 && totals.pd === 0 && totals.lf === 0 && totals.gp === 0 && totals.il > 0;
        var gpOnly = totals.general === 0 && totals.wc === 0 && totals.pd === 0 && totals.lf === 0 && totals.il === 0 && totals.gp > 0;
        var fs = wcOnly
          ? updateFsBar(totals.wc, getWcThreshold())
          : pdOnly
            ? updateFsBar(totals.pd, getPdThreshold())
            : lfOnly
              ? updateFsBar(totals.lf, getLfThreshold())
              : ilOnly
                ? updateFsBar(totals.il, getIlThreshold())
                : gpOnly
                  ? updateFsBar(totals.gp, getGpThreshold())
                  : updateFsBar(totals.general, getThreshold());
        if (fs.shown) {
          renderUpsells(cart.items);
          updateSavings(cart.items);
          attachExtrasObserver();
        }
      });
  }

  function runInit() {
    // Single deferred call — avoids 4 sequential fetches on each update.
    // 150ms gives Shopify's cart morph time to settle.
    clearTimeout(runInit._t);
    runInit._t = setTimeout(init, 150);
  }

  document.addEventListener('cart:update', runInit);

  document.addEventListener('dialog:open', function (e) {
    if (e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'cart-drawer-component') {
      runInit();
    }
  }, true);

  // Watch only #bo-cart-extras for style changes instead of body-wide subtree.
  // Catches cases where the cart resets without firing cart:update.
  // Called both at startup and after first successful render — the element doesn't
  // exist in the initial HTML when the cart is empty, so the startup call is a no-op
  // for new visitors; the call inside init() picks it up after the first add-to-cart.
  function attachExtrasObserver() {
    if (extrasObserved) return;
    var extras = document.getElementById('bo-cart-extras');
    if (!extras) return;
    var observer = new MutationObserver(function () {
      if (extras.style.display === 'none') init();
    });
    observer.observe(extras, { attributes: true, attributeFilter: ['style'] });
    extrasObserved = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      attachExtrasObserver();
    });
  } else {
    attachExtrasObserver();
  }

  // The cart page has no drawer-open event: count a visitor who lands on it with items.
  if (/\/cart\/?$/.test(location.pathname)) {
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { if (c.item_count > 0) trackCart(); }).catch(function () {});
  }

  window.__boCartInit = runInit;
})();
